import { createNamespacedHelpers } from "vuex";
import axios from 'axios';

const state = {
  isLoading: false,
  all: [],
  state: 'none', // none | showing | creating | editing,
  areaSelected: null,
  area: {
    id: null,
    name: ''
  }
}

const mutations = {
  startLoadAll(state) {
    state.isLoading = true;
  },
  loadAllSuccess(state, payload) {
    state.all = payload;
    state.isLoading = false;
  },
  selectArea(state, area) {
    state.areaSelected = area;
    state.state = 'showing';
  },
  startEdit(state) {
    state.state = 'editing';

    state.area.id = state.areaSelected.id;
    state.area.name = state.areaSelected.name;
  },
  reset(state) {
    state.state = state.area.id === null ? 'none' : 'showing';

    state.area.id = null;
    state.area.name = '';
  },
  updateName(state, name) {
    state.area.name = name;
  }
}

const actions = {
  async loadAllByEnterprise({ commit }, { enterpriseId, params }) {
    commit('startLoadAll');

    let response = await axios.get(`/api/enterprises/${enterpriseId}/areas`, {
      params: params
    });

    commit('loadAllSuccess', response.data.data);
  },
  startEditEnterprise({ commit }) {
    commit('startEdit');
  }
}

export const {
  mapState: mapAreasState,
  mapMutations: mapAreasMutations,
  mapActions: mapAreasActions,
} = createNamespacedHelpers('areas');

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
